export default {
  labels: {
    navigation: {
      home: 'Home',
      about: 'About us',
      contact: 'Contact',
      information: 'Information',
      partners: 'Partners'
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en_US.js